export default "__VITE_ASSET__a12bd6fc__"